import { MapTo } from '@adobe/aem-react-editable-components';
import ArticleFeed from './ArticleFeed';

export default MapTo('cob-corp-acquisition/components/creditonebank/article-feed')(ArticleFeed);